/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon24Solid = forwardRef('MathSumIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.86 6.469C1.988 5.004 3.024 2 5.4 2h14.1a1.5 1.5 0 0 1 0 3H6.85l6.43 5.031a2.5 2.5 0 0 1 0 3.938L6.85 19H19.5a1.5 1.5 0 0 1 0 3H5.4c-2.376 0-3.412-3.004-1.54-4.469L10.927 12 3.86 6.469Z" })));
});
